import script from "./overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./overview.vue?vue&type=script&lang=ts&setup=true"

import "./overview.vue?vue&type=style&index=0&id=6cab1f92&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cab1f92"]])

export default __exports__